export const THONG_TIN_XUAT_HOA_DON_PERMISSION_CODES = {
  WEB_BH_THONG_TIN_XUAT_HOA_DON_LIST: 'WEB_BH_THONG_TIN_XUAT_HOA_DON_LIST',
  WEB_BH_THONG_TIN_XUAT_HOA_DON_ADD: 'WEB_BH_THONG_TIN_XUAT_HOA_DON_ADD',
  WEB_BH_THONG_TIN_XUAT_HOA_DON_EDIT: 'WEB_BH_THONG_TIN_XUAT_HOA_DON_EDIT',
  WEB_BH_THONG_TIN_XUAT_HOA_DON_DELETE: 'WEB_BH_THONG_TIN_XUAT_HOA_DON_DELETE',
} as const

export type ThongTinXuatHoaDonPermissionCode =
  (typeof THONG_TIN_XUAT_HOA_DON_PERMISSION_CODES)[keyof typeof THONG_TIN_XUAT_HOA_DON_PERMISSION_CODES]

export const THONG_TIN_XUAT_HOA_DON_MUTATE_PERMISSIONS = [
  THONG_TIN_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_THONG_TIN_XUAT_HOA_DON_ADD,
  THONG_TIN_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_THONG_TIN_XUAT_HOA_DON_EDIT,
  THONG_TIN_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_THONG_TIN_XUAT_HOA_DON_DELETE,
] as const
